import React from "react";
import ServiceDetail from "@/pages/services/ServiceDetail";

const Washer = () => <ServiceDetail slug="washer" />;
export default Washer;
